/* Floodlight · ss-about.js (content)
   About chapters: the chapter nearest the viewport centre drives the sticky media
   (#ss-chap): data-ch (1-based), --ch (0-based, odometer numeral), .on on every image and
   tick up to that chapter, .cur on the current image. Port of parts/22-dom.js (chap block),
   generalised for any number of chapters. */
(function () {
  if (window.SS_LOADED_about) return;
  window.SS_LOADED_about = true;

  function ready(type, init) {
    if (window.SS && typeof SS.sectionReady === 'function') return SS.sectionReady(type, init);
    var run = function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="' + type + '"]'), function (el) { init(el); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  }

  function init(root) {
    if (!root || root.__ssAbout) return;
    var media = root.querySelector('[data-chap-media]');
    var chaps = Array.prototype.slice.call(root.querySelectorAll('.chap[data-i]'));
    if (!media || !chaps.length) return;
    root.__ssAbout = true;
    var images = Array.prototype.slice.call(media.querySelectorAll('.cm'));
    var ticks = Array.prototype.slice.call(media.querySelectorAll('.chap-ticks i'));
    var raf = 0;
    var current = 0;

    function apply(ch) {
      if (ch === current) return;
      current = ch;
      media.setAttribute('data-ch', String(ch));
      media.style.setProperty('--ch', String(ch - 1));
      images.forEach(function (img, i) {
        img.classList.toggle('on', i < ch);
        img.classList.toggle('cur', i === ch - 1);
      });
      ticks.forEach(function (t, i) { t.classList.toggle('on', i < ch); });
    }

    function update() {
      raf = 0;
      // the sticky column is hidden at 980 px and below; nothing to drive there
      if (!media.offsetParent) return;
      var vh = window.innerHeight || 900;
      var nearest = 1;
      var bd = Infinity;
      chaps.forEach(function (c) {
        var r = c.getBoundingClientRect();
        var d = Math.abs(r.top + r.height / 2 - vh * 0.5);
        if (d < bd) { bd = d; nearest = parseInt(c.getAttribute('data-i'), 10) || 1; }
      });
      apply(nearest);
    }

    function schedule() {
      if (!raf) raf = requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    current = parseInt(media.getAttribute('data-ch'), 10) || 1;
    schedule();

    return function destroy() {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (raf) cancelAnimationFrame(raf);
      root.__ssAbout = false;
    };
  }

  ready('page-about', init);
})();
